/**
 * Modern Device Detector
 */

class Detector {
	// Retrieve the user agent string
	get userAgent() {
		return navigator.userAgent || navigator.vendor || window.opera || '';
	}

	// Check if the device is a phone
	isPhone() {
		const phoneRegex =
			/(android|bb\d+|meego).+mobile|iphone|ipod|kindle|iemobile|opera m(ob|in)i|blackberry|palm|phone|netfront|symbian|treo|windows ce|vodafone/i;
		return phoneRegex.test(this.userAgent);
	}

	// Check if the device is a tablet
	isTablet() {
		const tabletRegex =
			/(ipad|android(?!.*mobile)|silk|playbook|tablet|nexus 7|nexus 10|kindle fire)/i;
		return tabletRegex.test(this.userAgent);
	}

	// Check if the device is a mobile device (phone or tablet)
	isMobile() {
		return this.isPhone() || this.isTablet();
	}
}

export default new Detector();
